import script from "./MinimizedCellLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./MinimizedCellLite.vue?vue&type=script&setup=true&lang=ts"

import "./MinimizedCellLite.vue?vue&type=style&index=0&id=7590daed&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7590daed"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
